import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Category } from '../product.model';
import { environment } from 'src/environments/environment';
import { webddn } from 'src/environments/webddn';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  //private apiUrl = environment.BASEURL + environment.API_DOMAIN + '/api/' + webddn.DOMAIN;

  constructor(private http: HttpClient) {}

  getAllCategories(): Observable<Category[]> {
    return this.http.get<any>(environment.BASEURL+environment.CATEGORIES_TREE_APIURL).pipe(
      map(response => {
        if (response && response.success && response.data) {
          // Transform the API response to match our Category model
          return this.transformCategories(response.data);
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching categories:', error);
        return of([]);
      })
    );
  }

  private transformCategories(apiCategories: any[]): Category[] {
    return apiCategories.map(cat => ({
      categories_id: cat.categories_id,
      categories_name: cat.description?.categories_name || '',
      categories_description: cat.description?.categories_description || '',
      categories_image: cat.categories_image,
      parent_id: cat.parent_id,
      sort_order: cat.sort_order,
      categories_status: cat.categories_status,
      product_count: 0 // Will be calculated separately if needed
    }));
  }

  getCategoryById(id: number): Observable<Category | null> {
    return this.http.get<any>(environment.BASEURL+environment.CATEGORY_APIURL+'/'+id).pipe(
      map(response => {
        if (response && response.category) {
          return response.category;
        }
        return null;
      }),
      catchError(error => {
        console.error('Error fetching category:', error);
        return of(null);
      })
    );
  }

  getCategoriesWithProductCount(): Observable<Category[]> {
    return this.http.get<any>(environment.BASEURL + environment.CATEGORIES_WITH_COUNT_APIURL).pipe(
      map(response => {
        if (response && response.categories) {
          return response.categories;
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching categories with count:', error);
        // Fallback to regular categories
        return this.getAllCategories();
      })
    );
  }

  getCategoryTree(): Observable<Category[]> {
    return this.http.get<any>(environment.BASEURL+environment.CATEGORIES_TREE_APIURL).pipe(
      map(response => {
        if (response && response.success && response.data) {
          return this.transformCategories(response.data);
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching category tree:', error);
        return of([]);
      })
    );
  }
}